/**
 * AWS Amplify Configuration for Google SSO Authentication
 */
import { Amplify } from 'aws-amplify';

// Get current environment
const getCurrentEnvironment = () => {
  const hostname = window.location.hostname;
  if (hostname.includes('localhost')) {
    return 'dev';
  } else if (hostname.includes('prod') || hostname.includes('bizcloudexperts.com') || hostname === 'd1wm1lbpv9vq11.cloudfront.net') {
    return 'prod';
  }
  return 'dev';
};

// Get redirect URLs based on environment
const getRedirectUrls = () => {
  const currentUrl = window.location.origin;
  const env = getCurrentEnvironment();
  
  return {
    signIn: [
      'http://localhost:3000/auth',
      `http://sow-generator-frontend-${env}.s3-website-us-east-1.amazonaws.com/auth`,
      `${currentUrl}/auth`
    ],
    signOut: [
      'http://localhost:3000',
      `http://sow-generator-frontend-${env}.s3-website-us-east-1.amazonaws.com`,
      currentUrl
    ]
  };
};

// AWS Amplify configuration
const awsConfig = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || '',
          scopes: [
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin'
          ],
          redirectSignIn: getRedirectUrls().signIn,
          redirectSignOut: getRedirectUrls().signOut,
          responseType: 'code',
          providers: ['Google']
        }
      }
    }
  }
};

// Configure Amplify
try {
  Amplify.configure(awsConfig);
  console.log('✅ AWS Amplify configured successfully');
  console.log('Environment:', getCurrentEnvironment());
  console.log('Redirect URLs:', getRedirectUrls());
} catch (error) {
  console.error('❌ Error configuring AWS Amplify:', error);
}

export default awsConfig;
